import PropTypes from 'prop-types';
import React from 'react';
import MaterialChip from '@mui/material/Chip';
import { noop } from 'Helpers/PropTypes';
import { tokens } from '@facet-wealth/design';
import CloseIcon from '@material-ui/icons/Close';
import { dataAttrs } from 'Helpers/Testing';

const FDChip = ({ label, onDelete, test }) => {
  return (
    <MaterialChip
      label={label}
      onDelete={onDelete}
      test={test}
      deleteIcon={<CloseIcon fontSize={'small'} {...dataAttrs('chip-delete-icon')} />} // Directly importing CloseIcon from material ui because our exported FDIcon will not work
      sx={{
        color: tokens.color_stone_800,
        backgroundColor: 'transparent',
        border: `1px solid ${tokens.color_stone_800}`,
        fontSize: tokens.font_size_200,
        fontWeight: tokens.font_weight_semibold,
        paddingRight: '12px',
      }}
    />
  );
};

FDChip.defaultProps = {
  onDelete: noop,
  test: 'chip',
};

FDChip.propTypes = {
  label: PropTypes.string.isRequired,
  onDelete: PropTypes.func, // Chip is not deletable if this is a noop
  test: PropTypes.string,
};

export default FDChip;
